import { render, staticRenderFns } from "./WorkspaceEditRoot.vue?vue&type=template&id=693ceff6"
import script from "./WorkspaceEditRoot.vue?vue&type=script&lang=ts"
export * from "./WorkspaceEditRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports